import { inject, injectable } from "inversify";
import IContractService from "./IContractService";
import { ContractsApi } from "../api/ContractsApi";
import { OperationsApi } from "../api/OperationsApi";
import { OperationRequestData } from "../../data/operationRequestData";
import { CardModel } from "../../models/contracts/cardModel";
import { ActionStateEnum } from "../../models/enums/operStateEnum";
import { IActionModel } from "../../models/IActionModel";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import IAlertService from "../alert/IAlertService";
import IErrorService from "../error/IErrorService";
import { DiTokens } from "../diTokens";

@injectable()
/**Сервис карт */
export default class CardService implements IContractService {
  constructor(
    @inject(DiTokens.AlertService) private alertService: IAlertService,
    @inject(DiTokens.ErrorService) private errorService: IErrorService
  ) {}

  /**
   * Получение списка объектов
   * @param ids Список Идентификаторов объектов для полного обновления
   */
  public async getList(ids: number[]): Promise<any> {
    console.log("getList/No implementation");
  }

  /**
   * Получение одного объекта
   * @param id Идентификатор запрашиваемого объекта
   */
  public async get(id: number): Promise<CardModel> {
    let card: CardModel = new CardModel();
    try {
      const resp = await ContractsApi.getCardAsync(id);
      const bankDetails = await ContractsApi.getAccountDetail(id);

      card = new CardModel(resp);
    } catch (e) {
      await this.errorService.errorHandler(e, false, true, "");
    }
    return card;
  }
  /**
   * Изменение псевдонима объекта
   * @param actionModel Data.cardId, Data.alias
   * */
  public async editAlias(actionModel: IActionModel): Promise<IActionModel> {
    try {
      const id: number = actionModel.Data["cardId"] as number;
      const alias: string = actionModel.Data["alias"] as string;
      await ContractsApi.editCardAliasAsync(id, alias);
      actionModel._actionState = ActionStateEnum.Success;
    } catch (e) {
      await this.errorService.errorHandler(e, false, true, "");
      actionModel._actionState = ActionStateEnum.Error;
      actionModel.ActionStateText = e.message;
    }
    return actionModel;
  }

  /**
   * Установка видимости объекта
   * @param actionModel Data.cardId, Data.alias
   */
  public async setVisibility(actionModel: IActionModel, respondentCode: string): Promise<IActionModel> {
    try {
      const id: number = actionModel.Data["cardId"] as number;
      const hidden: boolean = actionModel.Data["hidden"] as boolean;
      const ord: OperationRequestData = new OperationRequestData(null);
      ord.respondentCode = respondentCode;
      ord.setProperty(
        "cardId",
        id.toString(),
        DeclarationPropertiesTypes.Int
      );
      ord.setProperty(
        "hidden",
        hidden.toString(),
        DeclarationPropertiesTypes.Boolean
      );
      await OperationsApi.executeOperationSendAsync(ord);     
      actionModel._actionState = ActionStateEnum.Success;
      return actionModel;
    } catch (e) {
      await this.errorService.errorHandler(e, false, true, "");
      actionModel._actionState = ActionStateEnum.Error;
      actionModel.ActionStateText = e.message;
    }
    return actionModel;
  }

  /**Получение реквизитов счета
   * * @param id Идентификатор запрашиваемого объекта
   */
  public async getBankDetails(id: number): Promise<any> {
    console.log("getBankDetails/No implementation");
  }

  public async sendAccountDetail(actionModel: IActionModel): Promise<any> {
    console.log("sendAccountDetail/ No implementation");
  }

  public async getSmsPackets(): Promise<any> {
    console.log("getSmsPackets/No implementation");
  }

  public async getDepositForeCast(): Promise<any> {
    console.log("getDepositForeCast/No implementation");
  }

  public async getFile(): Promise<any> {
    console.log("getForecastFile/No implementation");
  }

  public async getCreditSchedule(): Promise<any> {
    console.log("getCreditSchedule/No implementation");
  }
}
